export default "__VITE_ASSET__JsMKQAGc__"